import React from "react";
import { BadgeCheck, Phone, ShieldCheck, Star } from "lucide-react";
import { contact } from "@/lib/site-data";
import {
  GoogleIcon,
  GoogleRatingBadge,
} from "@/components/site/GoogleRatingBadge";
import "./TrustBar.css";

export function TrustBar() {
  return (
    <aside
      className="trust-topbar"
      aria-label="Najważniejsze informacje o gwarancji i opiniach"
    >
      <div className="shell-wide trust-topbar-content">
        <a
          className="trust-topbar-guarantee"
          href="/#gwarancja"
          aria-label="Przejdź do sekcji pisemnej gwarancji w umowie"
        >
          <BadgeCheck size={17} aria-hidden="true" /> Pisemna gwarancja w umowie
        </a>
        <span className="trust-topbar-divider" aria-hidden="true" />
        <GoogleRatingBadge compact />
        <span className="trust-topbar-mobile-summary">
          <GoogleIcon />
          <span
            className="trust-topbar-mobile-stars"
            aria-label="5 na 5 gwiazdek"
          >
            <Star size={12} fill="currentColor" aria-hidden="true" />
          </span>
          <span className="trust-topbar-mobile-rating">5,0 · 249 opinii</span>
        </span>
        <a
          className="trust-topbar-mobile-guarantee"
          href="/#gwarancja"
          aria-label="Przejdź do sekcji pisemnej gwarancji w umowie"
        >
          <ShieldCheck size={17} aria-hidden="true" />
          <span>Pisemna Gwarancja</span>
        </a>
        <a
          className="trust-topbar-mobile-phone"
          href={contact.phoneHref}
          aria-label={`Zadzwoń: ${contact.phoneDisplay}`}
        >
          <Phone size={13} aria-hidden="true" />
          <span>{contact.phoneDisplay}</span>
        </a>
      </div>
    </aside>
  );
}
